import { render, staticRenderFns } from "./StockSubstockAssignedBuyerTypes.component.vue?vue&type=template&id=2419e536&scoped=true&"
import script from "./StockSubstockAssignedBuyerTypes.component.vue?vue&type=script&lang=js&"
export * from "./StockSubstockAssignedBuyerTypes.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2419e536",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VAutocomplete,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})
